/**
 * Created by pbo on 26/05/16.
 */

angular.module('taric.duty.calculate.results', ['taric.duty', 'taric.model.cd', 'taric.model.footnote', 'taric.auth.model',
    'common.template.footnote.popup', 'common.template.measure.popup', 'common.config', 'common.filter.description',
    'common.filter.decimalNumber', 'common.filter.decimalNumberCalcResult', 'common.helper', 'common.filter.specialCharacterToHtml'])
    .controller('CalculateDutyResultsCtrl', function ($translatePartialLoader, CalculateDutyModel, FootnotePopupModel, MeasurePopupModel, $uibModal, CONSTANTS, CommonHelper, $rootScope, $scope, $filter, MenuModel, AuthorizeModel) {
        $translatePartialLoader.addPart('taric/duties/calculate');
        var resultsCtrl = this;

        resultsCtrl.init = function () {
            // Backing data model for view
            resultsCtrl.model = CalculateDutyModel;

            resultsCtrl.calculationInput = CalculateDutyModel.getCalculationInput();
            resultsCtrl.calculationResult = CalculateDutyModel.getCalculationResult();

            if (resultsCtrl.calculationInput.tradeDirection === 'I') {
                resultsCtrl.isImport = true;
            } else {
                resultsCtrl.isImport = false;
            }

            var countriesAndregions = CalculateDutyModel.countriesAndRegions;
            var preferenceCodes = null;

            resultsCtrl.dateFormat = CONSTANTS.dateFormat;

            // Only display VAT note for Denmark.
            resultsCtrl.showVatNote = false;
            if (CONSTANTS.installationCountry.toUpperCase() === 'DK') {
                resultsCtrl.showVatNote = true;
            }

            // Only display dutyCalculatorLink for Sweden.
            resultsCtrl.dutyCalculatorLink = CONSTANTS.dutyCalculatorLink;

            resultsCtrl.additionalCodes = null;
            resultsCtrl.countryDescriptions = null;
            resultsCtrl.countryOfPreferentialOriginDescriptions = null;
            resultsCtrl.countryOfDispatchDescriptions = null;
            resultsCtrl.preferenceCodeDescriptions = null;
            resultsCtrl.supplementaryUnit = null;
            resultsCtrl.supplementaryUnitDescriptions = null;
            resultsCtrl.measurementUnits = null;
            
            if (resultsCtrl.calculationInput.additionalCodes !== null) {
                resultsCtrl.additionalCodes = '';
                var str;
                for (let i = 0; i < resultsCtrl.calculationInput.additionalCodes.length; i++) {
                    if (resultsCtrl.additionalCodes.length > 0) {
                        str = resultsCtrl.additionalCodes.concat(' ', resultsCtrl.calculationInput.additionalCodes[i]);
                        resultsCtrl.additionalCodes = str;
                    } else {
                        resultsCtrl.additionalCodes = resultsCtrl.calculationInput.additionalCodes[i];
                    }
                }
            }

            for (let i = 0; i < countriesAndregions.count; i++) {
                if (resultsCtrl.calculationInput.country === countriesAndregions.items[i].id) {
                    resultsCtrl.countryDescriptions = countriesAndregions.items[i].descriptions;
                    break;
                }               
            }

            if (resultsCtrl.calculationInput.countryOfPreferentialOrigin !== null) {
                for (let i = 0; i < countriesAndregions.count; i++) {
                    if (resultsCtrl.calculationInput.countryOfPreferentialOrigin === countriesAndregions.items[i].id) {
                        resultsCtrl.countryOfPreferentialOriginDescriptions = countriesAndregions.items[i].descriptions;
                        break;
                    }
                }
            }

            if (resultsCtrl.calculationInput.countryOfDispatch !== null) {
                for (let i = 0; i < countriesAndregions.count; i++) {
                    if (resultsCtrl.calculationInput.countryOfDispatch === countriesAndregions.items[i].id) {
                        resultsCtrl.countryOfDispatchDescriptions = countriesAndregions.items[i].descriptions;
                        break;
                    }
                }
            }

            if (resultsCtrl.calculationInput.preferenceCode !== null) {
                preferenceCodes = CalculateDutyModel.preferenceCodesAndSupplementaryUnit.preferenceCodes;
                for (let i = 0; i < preferenceCodes.count; i++) {
                    if (resultsCtrl.calculationInput.preferenceCode === preferenceCodes.items[i].id) {
                        resultsCtrl.preferenceCodeDescriptions = preferenceCodes.items[i].descriptions;
                        break;
                    }
                }
            }

            if (resultsCtrl.calculationInput.supplementaryUnitValue !== null) {
                resultsCtrl.supplementaryUnit = CalculateDutyModel.preferenceCodesAndSupplementaryUnit.mandatorySupplementaryUnit.id;
                resultsCtrl.supplementaryUnitDescriptions = CalculateDutyModel.preferenceCodesAndSupplementaryUnit.mandatorySupplementaryUnit.descriptions;
            }

            if (resultsCtrl.calculationInput.measurementUnits !== null) {
                resultsCtrl.measurementUnits = CalculateDutyModel.measurementUnits;

                // If configured decimalSeparator is not default value '.',
                // convert values to DecimalNumber before displaying on GUI by decimalNumber filter.
                if (CONSTANTS.decimalSeparator !== '.') {
                    for (let i = 0; i < resultsCtrl.measurementUnits.length; i++) {
                        resultsCtrl.measurementUnits[i].value = CommonHelper.getDecimalNumber(resultsCtrl.measurementUnits[i].value);
                    }
                }
            }

            resultsCtrl.errorMessages = [];
            resultsCtrl.infoMessages = [];
            if (resultsCtrl.calculationResult.messages.length !== 0) {
                let erroridx = 0;
                let infoidx = 0;
                for (let i = 0; i < resultsCtrl.calculationResult.messages.length; i++) {
                    if (resultsCtrl.calculationResult.messages[i].severity === 'INFORMATION') {
                        resultsCtrl.infoMessages[infoidx] = resultsCtrl.calculationResult.messages[i].descriptions;
                        infoidx++;
                    } else { // severity = 'ERROR'
                        resultsCtrl.errorMessages[erroridx] = resultsCtrl.calculationResult.messages[i].descriptions;
                        erroridx++;
                    }
                }
            }

            resultsCtrl.measureMap= {};
            for (let i = 0; i < resultsCtrl.calculationResult.measures.length; i++) {
                resultsCtrl.measureMap[resultsCtrl.calculationResult.measures[i].sid] = resultsCtrl.calculationResult.measures[i];
            }

            resultsCtrl.infoCode = CommonHelper.validateSimulationDateAfterOrBefore(resultsCtrl.calculationInput.simulationDate);
            if (resultsCtrl.infoCode &&
                "i8n.common.pastDate" === resultsCtrl.infoCode) {
                resultsCtrl.infoParams = CONSTANTS.pastDate;
            }

            resultsCtrl.model = CalculateDutyModel;
            resultsCtrl.model.loggedIn = AuthorizeModel.loggedIn;
            if (CONSTANTS.releaseManagement) {
                resultsCtrl.model.includeUnreleased = AuthorizeModel.loggedIn && AuthorizeModel.isIncludedUnreleasedDataViewer();
            } else {
                resultsCtrl.model.includeUnreleased = false;
            }
        };

        resultsCtrl.openFootnotePopup = function (size, footnoteId) {
            $uibModal.open({
                animation: true,
                templateUrl: 'common/popup/footnote/footnote-popup.tmpl.html',
                controller: 'FootnotePopupController as footnotePopupCtrl',
                size: size,
                resolve: {
                    footnote: function (FootnotePopupModel) {
                        return FootnotePopupModel.findFootnote(footnoteId, resultsCtrl.calculationInput.simulationDate);
                    }
                }
            });
        };

        resultsCtrl.openMeasurePopup = function(size, measure) {
            var preferenceCodesForMeasureOnly = false;
            $uibModal.open({
                animation: true,
                templateUrl: 'common/popup/measure/measure-popup.tmpl.html',
                controller: 'MeasurePopupController as measurePopupCtrl',
                size: size,
                resolve: {
                    measureExtendedInfo: function (MeasurePopupModel) {

                        return MeasurePopupModel.getMeasureExtendedInfoForMeasureType(measure.sid, preferenceCodesForMeasureOnly, resultsCtrl.calculationInput.commodityCode,
                            resultsCtrl.calculationInput.country, resultsCtrl.calculationInput.tradeDirection, resultsCtrl.calculationInput.preferenceCode,
                            resultsCtrl.calculationInput.additionalCodes, resultsCtrl.calculationInput.simulationDate,resultsCtrl.calculationInput.version);
                    }
                }
            });
        };

        // this method is used for traversing the DOM inside the calculate of duties
        // remember that, it only extract visible DOM elements except elements that has classes hidden-div or hidden-table
        resultsCtrl.getChildElements = function(doc, element, options) {

        	var elements = element.children;
        	for (let i = 0; i < elements.length; i++) {
        	
        	   if (elements[i].id != 'infoTable') {

            	   if ((elements[i].className.indexOf('hidden-div') != -1 || elements[i].className.indexOf('hidden-table') != -1) || !!( elements[i].offsetWidth || elements[i].offsetHeight || elements[i].getClientRects().length )) {

                       	var name = elements[i].nodeName.toLowerCase();
                       	if (name == 'p' || name == 'span') {

                            if (elements[i].innerHTML.indexOf('dutyCal.gif') != -1) {
                                // Print calculator icon and DutyCalculatorLink text when there is preference "dutyCalculatorLink"
                                doc.push ({ text: '\n' });
                                doc.push({
                                    table: {
                                        widths: ['*']['*'],
                                        body: [[{ // Get DutyCalculatorLink image
                                            image: 'dutyCal',
                                            alignment : 'left',
                                            margin: [0, 0, 0, 0],
                                            width: 12,
                                            height: 12
                                        }, { // Get DutyCalculatorLink text
                                            text: elements[i].getElementsByClassName('text-left')[0].innerHTML,
                                            alignment : "left",
                                            fontSize: 8.5,
                                            bold: false
                                        }]]
                                    },
                                    layout: 'noBorders'
                                });

                            } else if (elements[i].className.indexOf('alert') != -1) {
                                // Print errorMessages or infoMessages
                                // Remove all html tag and special characters. Only keep text content
                                var text = elements[i].innerHTML.replace(/<(?:.|\n)*?>/gm, '');
                                doc.push ({ text: '\n' });
                           		doc.push({
                           			table: {
        								widths: ['*'],
        								body: [[{
                                        	text: text,
                                            alignment : "left",
                                            fontSize: 9,
                                            bold: true
                                        }]]
                           			}
                                });
                       		} else {

                       			if (doc.length > 0) {
                       				doc.push ({ text: '\n' });
                       			}
                       			
                           		var bold = elements[i].className.indexOf('-tab-heading') != -1 || elements[i].className.indexOf('dutycal-underline') != -1 ? true : false;
                           		doc.push ({
                           			text: elements[i].innerHTML,
                           			fontSize: bold ? 9 : 8.5,
                           			bold: bold,
                           			decoration: elements[i].className.indexOf('dutycal-underline') != -1 ? 'underline' : ''
                           		});
                       		}
                       	} else if (name == 'table') {
                       		
                       		// print table if it is a table
                       		CommonHelper.htmlTableToPdf(doc, elements[i], options);
            	    	} else if (name == 'div') {

                       		// keep printing if it is div
            	    		resultsCtrl.getChildElements(doc, elements[i], options);
            	    	} else if (name == 'form') {

                       		// keep printing if it is form
            	    		resultsCtrl.getChildElements(doc, elements[i], options);
            	    	}
            	   }
        	   }
        	}
        };
        
        resultsCtrl.print = function(options) {
            $rootScope.$broadcast('startSpinningPrint');
            $scope.$apply();

            //Prepare the html document for printing pdf
            let doc = [];
            let el = document.getElementById("results");
            let els = el.getElementsByClassName("nav-tabs");

            angular.forEach(els, function(el){
                el.dataset.oldDisplay = el.style.display;
                el.style.display='none';
            });

            els = el.getElementsByClassName("tab-pane");
            angular.forEach(els, function(el){
                el.dataset.oldDisplay = el.style.display;
                el.style.display='block';
            });
	       	
        	resultsCtrl.getChildElements(doc, document.getElementById('calculateDutyResults'), options);

        	//Update the html document to the original state
            els = el.getElementsByClassName("nav-tabs");
            angular.forEach(els, function(el){
                el.style.display = el.dataset.oldDisplay;
                el.dataset.oldDisplay = null;
            });

            els = el.getElementsByClassName("tab-pane");
            angular.forEach(els, function(el){
                el.style.display=el.dataset.oldDisplay;
                el.dataset.oldDisplay = null;
            });

        	CommonHelper.printPlainDocument({
            	contents: doc,
            	logo: options.logo,
                flag: resultsCtrl.flagImg,
                eu: resultsCtrl.euImg,
                checked: resultsCtrl.checkedImg,
                unchecked: resultsCtrl.uncheckedImg,
                unreleased: resultsCtrl.unreleasedImg,
                dutyCal: resultsCtrl.dutyCalImg,
            	validDate: $filter('date')(resultsCtrl.calculationInput.simulationDate, CONSTANTS.dateFormat),
            	title: $filter('translate')('i8n.qry.cd.query.tab.calculate.title')
            }, 'l').then(() => {

                $rootScope.$broadcast('stopSpinningPrint');
            }, (error) => {

                $rootScope.$broadcast('stopSpinningPrint');
            });
        };
	       	
    	$scope.$on('printDocument', function(event, data) {

          	$rootScope.$broadcast('stopSpinningPrint');

          	// preload nation flag of the report
        	CommonHelper.loadImage("img/flags/" + resultsCtrl.model.installationCountry + ".png", 21, 14, function(data){

                resultsCtrl.flagImg = data.logo;
        		
        		// preload logo of the report
        		// size of logo must be multipled 2 because it will increase resolution
        		CommonHelper.loadImage(CommonHelper.getLogoImagePath(), CONSTANTS.pdfExport.logoWidth * 2, CONSTANTS.pdfExport.logoHeight * 2, resultsCtrl.print, true);
        	}, true);
        });
    	
    	// preload load images that are being used in the report.
    	CommonHelper.loadImage("img/status/checked.png", 16, 16, function(data) {
            resultsCtrl.checkedImg = data.logo;
    	}, true);

    	CommonHelper.loadImage("img/status/notchecked.png", 21, 14, function(data){

            resultsCtrl.uncheckedImg = data.logo;
    	}, true);
    	
    	CommonHelper.loadImage("img/flags/EU.png", 21, 14, function(data){

            resultsCtrl.euImg = data.logo;
    	}, true);

    	CommonHelper.loadImage("img/status/unreleased.gif", 21, 14, function(data){

            resultsCtrl.unreleasedImg = data.logo;
        }, true);

        CommonHelper.loadImage("img/references/dutyCal.gif", 20, 20, function(data){

            resultsCtrl.dutyCalImg = data.logo;
        }, true);

    	if (MenuModel) {

        	MenuModel.enablePrintable();
        	MenuModel.notifyObservers();
    	}
    });



// WEBPACK FOOTER //
// ./app/taric/duties/calculate/results/cd-results.js